import React from "react"
import Title from "../Title"
import styles from "../../css/about.module.css"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import AniLink from "gatsby-plugin-transition-link/AniLink"

const getAbout = graphql`
  query about {
    aboutImage: file(relativePath: { eq: "defaultBcg.jpeg" }) {
      childImageSharp {
        fluid(maxWidth: 600) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    aboutDesc: site {
      siteMetadata {
        description
      }
    }
  }
`

const About = () => {
  const { aboutImage, aboutDesc } = useStaticQuery(getAbout)
  return (
    <section className={styles.about}>
      <Title title="A" subtitle="propos" />
      <div className={styles.aboutCenter}>
        <article className={styles.aboutInfo}>
          <h4>Vivez la différence</h4>
          <p>{aboutDesc.siteMetadata.description}</p>
          <AniLink fade to="/lieu" className="btn-primary">
            en savoir plus
          </AniLink>
        </article>
        <article className={styles.aboutImg}>
          <div className={styles.imgContainer}>
            <Img
              fluid={aboutImage.childImageSharp.fluid}
              alt="Le Moulin de Gâteau"
            />
          </div>
        </article>
      </div>
    </section>
  )
}

export default About
